import { useMutation } from '@tanstack/react-query';
import { queryClient } from '@/config/reactQuery';
import { QUERY_KEYS } from '../../queryKeys';
import { billOfLading } from '../BillOfLading';

export const useUploadBillOfLading = () =>
  useMutation({ mutationFn: billOfLading.uploadBillOfLading });

export const useDeleteBillOfLading = () =>
  useMutation({
    mutationFn: billOfLading.deleteBillOfLading,
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.orderSummary],
      }),
  });
